import { createSlice } from '@reduxjs/toolkit'
import {
  getOrganizations,
  getAllOrganizations,
  createOrganization,
  updateOrganization,
  deleteOrganization,
} from '../actions/organizationsActions'

const initialState = {
  organizations: [],
  pagination: {},
}

const sortByName = (organizations) => organizations.sort((a, b) => a.name.localeCompare(b.name))

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrganizations.fulfilled, (state, action) => {
        const { organizations, meta } = action.payload
        const append = action.meta.arg?.append && meta.pagination.page > 1

        state.organizations = append ? [...state.organizations, ...organizations] : organizations
        state.pagination = meta.pagination
      })
      .addCase(getAllOrganizations.fulfilled, (state, action) => {
        state.organizations = action.payload.organizations
        state.pagination = action.payload.meta.pagination
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        state.organizations.push(action.payload.organization)
        sortByName(state.organizations)
        state.pagination.totalCount = (state.pagination.totalCount || 0) + 1
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        const index = state.organizations.findIndex(o => o.id === action.payload.organization.id)

        state.organizations[index] = action.payload.organization
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        state.organizations = state.organizations.filter(o => o.id !== action.payload)
        state.pagination.totalCount = Math.max((state.pagination.totalCount || 1) - 1, 0)
      })
  },
})

export default organizationsSlice.reducer
